var $ = jQuery;
// 更改某个商品折扣
var $ = jQuery;
$(function () {
  $('.special_product_tabCon #wigs_tab2 li').each(function () {
    // if($(this).data("id")=='7940550000882'){
    //   $(this).find('.price span .money').text('$109.00');
    // }
  });
  $('.seckill ul li').each(function () {
    if ($(this).data('id') == '7940550000882') {
      $(this).find('.two span').text('$99');
    }
  });
});
function getLocalTime(i) {
  if (typeof i !== 'number') return;
  var d = new Date();
  var len = d.getTime();
  var offset = d.getTimezoneOffset() * 60000;
  var utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
}

window.getNextDate = function (date, day) {
  var dd = new Date(date);
  console.log(dd);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
  return y + '/' + m + '/' + d;
};

var timeZoneParams = -6;
$(function () {
  if ($('.ht').length) {
    var date = getLocalTime(timeZoneParams);
    var date_day = date.getDate();
    var date_month = date.getMonth() + 1;
    var date_year = date.getFullYear();
    var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
    var endAllTime = new Date(endTime).getTime() - date;

    function timerMember(intDiff) {
      var hour = 0,
        minute = 0,
        second = 0;
      intDiff = intDiff - 0;
      if (intDiff > 0) {
        hour = Math.floor(intDiff / 1000 / 60 / 60);
        minute = Math.floor((intDiff / 1000 / 60) % 60);
        second = Math.floor((intDiff / 1000) % 60);
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (second < 10) {
        second = '0' + second;
      }
      $('.newhour').html(hour);
      $('.newmin').html(minute);
      $('.newmiao').html(second);
    }
    var groupTime = setInterval(function () {
      if (endAllTime > 0) {
        timerMember(endAllTime);
        endAllTime -= 1000;
      } else {
        date = getLocalTime(timeZoneParams);
        date_day = date.getDate();
        date_month = date.getMonth();
        date_year = date.getFullYear();
        endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
        endAllTime = new Date(endTime).getTime() - date;
      }
    }, 1000);
  }
});
// tab切换；
jQuery('.wigs .wigs_title')
  .off('click')
  .on('click', function () {
    // jQuery('.Form--spacingTight .Form__Header .Form__Title').click(function(){
    jQuery(this)
      .addClass('color1') // 返回 jQuery(this)
      .siblings() // 返回ul下li的兄弟
      .removeClass('color1') // 返回ul下li的兄弟
      .parent() // 返回ul
      .next() // 返回ol
      .children() // 返回ol下所有li
      .eq(jQuery(this).index()) // 返回ol下的一个li
      .addClass('active') // 返回ol下的一个li
      .siblings() // 返回ol下li的兄弟
      .removeClass('active'); // 返回ol下li的兄弟
  });
// setTimeout(function() {
//     $(".goods-one").click(function() {
//         $('#wigs_tab2').addClass('none');
//         $('#wigs_tab1').removeClass('none');
//     });
// }, 100);
// setTimeout(function() {
//     $(".goods-two").click(function() {
//         $('#wigs_tab1').addClass('none');
//         $('#wigs_tab2').removeClass('none');
//     });
// }, 100);
setTimeout(function () {
  $('.wigs .left').click(function () {
    $('.wigs .left').addClass('color1');
    $('.wigs .right').removeClass('color1');
    $('.wigs .left .goods-two').addClass('color2');
    $('.wigs .right .goods-one').removeClass('color2');
  });
}, 100);
setTimeout(function () {
  $('.wigs .right').click(function () {
    $('.wigs .left').removeClass('color1');
    $('.wigs .right').addClass('color1');
    $('.wigs .left .goods-two').removeClass('color2');
    $('.wigs .right .goods-one').addClass('color2');
  });
}, 100);
// setTimeout(function() {
//    $('.seckill li').each(function() {
//         var index = $(this).index();
//         console.log(index);
//         console.log('开始进行判断');
//         if ($(this).index() < 1 || $(this).index() == 1) {
//             console.log('第一个判断');
//             $(this).find('.seckill-c .one').show();
//             // $('.seckill-c .one').show()
//         } else {
//             $(this).find('.seckill-c .one').hide();
//             // $('.seckill-c .one').hide()
//         }

//     })
// }, 100);
